import { RepositoryFactory } from '../repositories/PassageApi/RepositoryFactory.js'
import CredentialsService from '../services/CredentialsService.js'

const DwExerciseDetailRepository = RepositoryFactory.get('dwExerciseDetail')

class DwExerciseDetailService {
  static async getExerciseDetails (params) {
    try {
      return await DwExerciseDetailRepository.getExerciseDetails(CredentialsService.getCurrentTenantId(), params)
    } catch (error) {
      console.log(error)
    }
  }
}

export default DwExerciseDetailService
